/**
 * Live bridge: NotificationContext → open customer ticket conversation.
 * Kept dependency-free so unit tests do not need the full auth/crypto stack.
 */

export const CUSTOMER_TICKET_ACTIVITY_EVENT = 'hd:customer-ticket-activity';

const CUSTOMER_TICKET_ACTIVITY_TYPES = new Set([
  'ticket_reply',
  'customer_ticket_reply',
  'ticket_update',
]);

/**
 * Notify the open customer ticket UI that conversation/status may have changed.
 * No-op for unrelated notification types.
 */
export function emitCustomerTicketActivity(notification) {
  if (typeof window === 'undefined' || !notification) {
    return;
  }
  const notificationType = String(
    notification.notificationType || notification.type || ''
  ).toLowerCase();
  if (!CUSTOMER_TICKET_ACTIVITY_TYPES.has(notificationType)) {
    return;
  }
  const ticketId =
    notification.ticketId ??
    notification.metadata?.ticketId ??
    notification.data?.ticketId ??
    null;
  const ticketNumber =
    notification.ticketNumber ??
    notification.metadata?.ticketNumber ??
    notification.data?.ticketNumber ??
    null;
  if (ticketId == null && !ticketNumber) {
    return;
  }
  window.dispatchEvent(
    new CustomEvent(CUSTOMER_TICKET_ACTIVITY_EVENT, {
      detail: {
        ticketId,
        ticketNumber,
        notificationType,
        notificationId: notification.notificationId ?? notification.id ?? null,
      },
    })
  );
}
